document.addEventListener("DOMContentLoaded", () => {

  document.addEventListener("submit", function(event){

    const form = event.target;

    if(!form.matches(".nrw-product-form")) return;

    event.preventDefault();

    const button = form.querySelector(".nrw-cart-button");

    const originalText = button.innerHTML;

    button.disabled = true;
    button.innerHTML = "Adding...";

    fetch("/cart/add.js",{
      method:"POST",
      body:new FormData(form),
      headers:{
        "Accept":"application/json"
      }
    })

    .then(response=>response.json())

    .then(data=>{

      button.innerHTML="✓ Added";

      document.dispatchEvent(new CustomEvent("cart:refresh"));

      setTimeout(()=>{

        button.innerHTML=originalText;
        button.disabled=false;

      },1500);

    })

    .catch(error=>{

      console.error(error);

      button.innerHTML="Try Again";

      setTimeout(()=>{

        button.innerHTML=originalText;
        button.disabled=false;

      },1500);

    });

  });

});